<template>
  <form action="">
    <div :class="['form-group', 'sml_mrgn', { 'has-warning': hasErrors } ]">
      <input type="text"
             :class="['form-group__textfield', extraClass]"
             v-model="input"
             @change="$emit('input', input)"
             :placeholder="placeholderText"/>
       <span class="form-group__feedback" v-if="hasErrors">
        {{ errorText }}
       </span>
    </div>
    <input type="submit"
           v-if="hasSubmit"
           :value="submitText"
           @click.prevent="actionOnClick(input)"
           :class="['btn2', 'btn2--std btn2--small btn2--fixed', { deactivated: !input }]">
    <div class="success_msg" v-if="hasSuccess">
      <p>{{ successText }}</p>
    </div>
  </form>
</template>

<script>
export default {
  name: 'form-field',
  props: {
    actionOnClick: Function,
    placeholderText: String,
    submitText: String,
    errorText: String,
    extraClass: String,
    successText: String,
    hasErrors: Boolean,
    hasSuccess: Boolean,
    hasSubmit: { type: Boolean, default: true },
  },
  data() {
    return {
      input: '',
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/shared/FormField.vue